import {Component, Input, OnInit} from '@angular/core';
import StyleFormatter from '../../../utils/style-formatter';

@Component({
  selector: 'resource-groups-summary',
  templateUrl: './resource-groups-summary.component.html',
  styleUrls: ['./resource-groups-summary.component.scss']
})
export class ResourceGroupsSummaryComponent implements OnInit {

  styleFormatter;

  @Input() selection: any;

  constructor() {
    this.styleFormatter = StyleFormatter;
  }

  ngOnInit(): void {
  }

}
